export function getCDNUrlFromFilename(filename: string, width?: number): string {
  return `https://cdn.thearc.dev/v1/assets/stro-me/assets/${filename + (width ? `?width=${width}` : "")}`;
}
